// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"5560": "main-dashboard","9905": "vendor-rich-text",}[chunkId] || chunkId) + ".bundle." + __webpack_require__.h().slice(0, 6) + ".css"
}